import HTTP from './HTTP.js';
import SymfonyErrorFormatter from './SymfonyErrorFormatter';

class PropertiesServices {
    static constructor()
    {}

    static setAgency(agency)
    {
        this.agency = agency;
        return this;
    }

    static getAgency()
    {
        return this.agency;
    }

    static getProperties(include, exclude, query)
    {
        let baseUrl = 'properties';

        if (typeof this.agency !== 'undefined') {
            baseUrl = `${baseUrl}/${this.agency.id}/agency`;
        } else {
            return;
        }

        return HTTP.get(baseUrl,{
            params: {
                include: include,
                exclude: exclude,
                query: query,
                limit: 5000,
            }
        })
            .then((response) => {
                return {
                    data: response.data.properties,
                    meta: response.data.meta
                }
            }).catch(() => {
                return Promise.reject('Could not get End Point');
        });
    }

    static getProperty(propertyId, includes) {
        return HTTP.get(`properties/${propertyId}`, {
            params: {
                include: includes
            }
        })
            .then((response) => {
                return response.data;
            }).catch(() => {
                return Promise.reject('Could not get End Point');
            });
    }

    static uploadLogo(agencyId, formData) {
        return HTTP.post(`agencies/${agencyId}/logo`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
        })
            .then((response) => {
                return response.data;
            }).catch(error => {
                return SymfonyErrorFormatter.clean(error.response);
            });
    }

    static updateAgency(agency) {
        return HTTP.post(`agencies/${agency.id}`, agency)
            .then((response) => {
                return response.data;
            }).catch(error => {
                return SymfonyErrorFormatter.clean(error.response);
            });
    }

    static updatePermission(agency, permission) {
        return HTTP.post(`agencies/${agency.id}/permissions/${permission.id}`, permission)
            .then((response) => {
                return response.data;
            }).catch(error => {
                return SymfonyErrorFormatter.clean(error.response);
            });
    }

    static createAgency(agency) {
        agency.status = 'published';
        return HTTP.post(`agencies`, agency)
            .then((response) => {
                // Transformer needs to include address by default;
                return response.data;
            }).catch(error => {
                return SymfonyErrorFormatter.clean(error.response);
            });
    }

    static getSignifiProductData(propertyId, agentCampaign) {
        return HTTP.post(`properties/signifi/product/${propertyId}`, agentCampaign)
            .then((response) => {
                return response.data;
            }).catch(error => {
                return SymfonyErrorFormatter.clean(error.response);
            })
    }

}

export default PropertiesServices;
